import React, { useState, useRef } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import TeamInfo from "./TeamInfo/TeamInfo";
import FilmsDetails from "./FilmsDetails/FilmsDetails";
import Declaration from "./Declaration/Declaration";
import Preview from "./CmotPreview/Preview";
import "./cmotStyle.css";
import { Container } from "@mui/material";
import dayjs from "dayjs";
import { styled } from "@mui/material/styles";
// import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import logo from "../../assets/images/IFFFI_LOGO.png";
import logo1 from "../../images/ashok-logo.png";
import logo2 from "../../assets/images/NFDC-Logo.png";
import { postRequest, getRequest } from "../../API/IP";

import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";

import { validateEmail } from "../Helper";
import CmotSubmission from "./CmotSubmission/CmotSubmission";
import { calculateAge } from "../Helper";
import Loader from "../common/Loader/Loader";
import EntryDetails from "./EntryDetails/EntryDetails";
import Aitools from "./Aitools/Aitools";
import Aistages from "./Aistages/Aistages";
import Submission from "../ip/Submission/Submission";

const steps = [
  "Entry Details",
  "Team Info",
  "AI Info",
  "AI Stages",
  "Preview",
  "Compliance & Declaration ",

];

const CinemaStepperData = () => {
  const scrollUp = () => {
    // console.log("test");
    const body = document.querySelector("#root");

    body.scrollIntoView(
      {
        behavior: "smooth",
      },
      500
    );
  };
  const [loading, setLoading] = useState(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const { id = null, ip_step = 1 } = useParams();
  // console.log({ id });
  const [preData, setPredata] = useState({});
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const [completed, setCompleted] = useState({});

  const [EntryDetailErrors, setEntryDetailErrors] = useState({});
  const [addressDetailsErrors, setAddressDetailsErrors] = useState({});
  const [filmDetailsErrors, setFilmDetailsErrors] = useState({});
  const [atToolErrors, setAtToolErrors] = useState({});
  const [atstageErrors, setAtstageErrors] = useState({});
  const [declarationErrors, setDeclarationErrors] = useState({});

  const verifyExistingRecord = async () => {
    // if (id) return true;
    // const predata = await getRequest(`cinemai/${id}`);
    // const data = predata.data;
    // if (data.length >= 1) {
    //   alert("You have reached maximum limit.");
    //   dashboardnavi("/dashboard");
    // }
  };

  const loadpreData = async () => {
    if (id) {
      try {
        const predata = await getRequest(`cinemai/${id}`, {});
        const loadpredata = predata.data;
        if (loadpredata.step >= 6) {
          navigate(`/cinemai-hackathon/view/${id}`);
        }
        setActiveStep(loadpredata.step);
        const loaddata = loadpredata?.payload || {};

        // Parse team_members and ai_tools from the loaded data, not from formData
        let parsedTeamMembers = [];
        let parsedAiTools = [];

        if (typeof loaddata?.team_members === 'string') {
          try {
            parsedTeamMembers = JSON.parse(loaddata.team_members);
            loaddata['team_members'] = Array.isArray(parsedTeamMembers) ? parsedTeamMembers : [];
          } catch (e) {
            console.error("Error parsing team_members:", e);
            loaddata['team_members'] = [];
          }
        }

        if (typeof loaddata?.ai_tools === 'string') {
          try {
            parsedAiTools = JSON.parse(loaddata.ai_tools);
            loaddata['ai_tools'] = Array.isArray(parsedAiTools) ? parsedAiTools : [];
          } catch (e) {
            console.error("Error parsing ai_tools:", e);
            loaddata['ai_tools'] = [];
          }
        }

        setFormData(loaddata);
        setPredata(predata.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  // Show modal when component mounts
  useEffect(() => {
    loadpreData();

  }, []);

  const [openDialog, setOpenDialog] = useState(false);
  // const [dialogAction, setDialogAction] = useState(null);

  const dialogAction = useRef(null);

  const handleDialogClose = async (confirm) => {
    setOpenDialog(false);
    if (confirm && dialogAction.current) {
      await dialogAction.current();
    }
  };

  const handleComplete = async () => {
    const newCompleted = { ...completed };
    newCompleted[activeStep] = true;
    // handleNext();
    // scrollUp()
    // console.log('Starting handleComplete with activeStep:', activeStep, 'and id:', id);
    // Validate current step data
    // let isValid = true;

    // step 1 Personal Detail
    scrollUp();
    setLoading(true);
    // step 1 Entry Details
    if (activeStep === 0) {
      const { isValid, errors } = validateEntryDetails(formData);
      if (!isValid) {
        setLoading(false);
        setEntryDetailErrors(errors);
        return;
      }

      try {
        let response;
        if (id) {
          //formData["last_id"] = id;
          response = await postRequest(`cinemai/update/${id}`, {
            ...formData,
            step: 1,
            team_members: Array.isArray(formData.team_members) ? JSON.stringify(formData.team_members) : null,
            ai_tools: Array.isArray(formData.ai_tools) ? JSON.stringify(formData.ai_tools) : null,
          });
        } else {
          response = await postRequest("cinemai", { ...formData, step: 1 });
        }

        setTimeout(() => {
          setLoading(false); // Set loading to false once the operation is complete
        }, 1000);
        if (response.status) {
          navigate(`/cinemai-hackathon/${response.data}/`);
          setActiveStep(1);
        } else {
          const serverErrors = response.data || {};
          // Trim keys in the server error object
          const trimmedServerErrors = Object.keys(serverErrors).reduce(
            (acc, key) => {
              acc[key.trim()] = serverErrors[key];
              return acc;
            },
            {}
          );

          setEntryDetailErrors((prevErrors) => ({
            ...prevErrors,
            ...trimmedServerErrors,
          }));

          return;
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }

    // step 2 Team Info
    if (activeStep === 1) {
      const { isValid, errors } = validateTeamInfo(formData);
      // console.log(errorsAddrerss)
      if (!isValid) {
        setAddressDetailsErrors(errors);
        setLoading(false);
        return; // Stop execution if validation fails
      } else {
        setAddressDetailsErrors({})
      }
      if (!id) {
        console.error("ID is not available.");
        return;
      }

      const updatedFormData = {
        ...formData,

        step: 2,
        team_members: Array.isArray(formData.team_members) ? JSON.stringify(formData.team_members) : null,
        ai_tools: Array.isArray(formData.ai_tools) ? JSON.stringify(formData.ai_tools) : null,

      };
      // console.log({ updatedFormData });

      try {
        const cmot_details_check = await postRequest(
          `cinemai/update/${id}`,
          updatedFormData
        );
        setTimeout(() => {
          setLoading(false); // Set loading to false once the operation is complete
        }, 1000);
        if (cmot_details_check.status) {
          handleNext();
          //navigate(`/ip/${id}/2`);
          // setActiveStep(2);
        } else {
          alert(cmot_details_check.message);
          return;
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }

    // step 3 AI Info
    if (activeStep === 2) {
      // Validation for the Director Details step

      const { isValid, errors } = validateAiTool(formData);

      if (!isValid) {
        setLoading(false);
        setAtToolErrors(errors);
        return;
      } else {
        setAtToolErrors({})
      }

      if (!id) {
        console.error("ID is not available.");
        return;
      }
      const updatedFormData = {
        ...formData,

        step: 3,
        last_id: id,
        team_members: Array.isArray(formData.team_members) ? JSON.stringify(formData.team_members) : null,
        ai_tools: Array.isArray(formData.ai_tools) ? JSON.stringify(formData.ai_tools) : null,
      };

      try {
        const cmot_details_check = await postRequest(
          `cinemai/update/${id}`,
          updatedFormData
        );
        // console.log(cmot_details_check);
        setTimeout(() => {
          setLoading(false); // Set loading to false once the operation is complete
        }, 1000);
        if (cmot_details_check.status) {
          handleNext();
        } else {
          alert(cmot_details_check.message);
          return 0;
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }

    // step 4 AI Stages
    if (activeStep === 3) {
      const { isValid, errors } = validateAiStage(formData);

      if (!isValid) {
        setLoading(false);
        setAtstageErrors(errors);
        return;
      } else {
        setAtstageErrors({})
      }


      const updatedFormData = {
        ...formData,
        step: 4,
        last_id: id,
        team_members: Array.isArray(formData.team_members) ? JSON.stringify(formData.team_members) : null,
        ai_tools: Array.isArray(formData.ai_tools) ? JSON.stringify(formData.ai_tools) : null,
      };
      try {
        const cmot_details_check = await postRequest(
          `cinemai/update/${id}`,
          updatedFormData
        );
        setTimeout(() => {
          setLoading(false); // Set loading to false once the operation is complete
        }, 1000);
        if (cmot_details_check.status) {
          handleNext();
        } else {
          alert(cmot_details_check.message);
          return;
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }

    // step 5 Preview
    if (activeStep === 4) {
      const updatedFormData = {
        ...formData,
        step: 5,
        team_members: Array.isArray(formData.team_members) ? JSON.stringify(formData.team_members) : null,
        ai_tools: Array.isArray(formData.ai_tools) ? JSON.stringify(formData.ai_tools) : null,
      };
      try {
        const cmot_details_check = await postRequest(
          `cinemai/update/${id}`,
          updatedFormData
        );
        setTimeout(() => {
          setLoading(false); // Set loading to false once the operation is complete
        }, 1000);
        if (cmot_details_check.status) {
          handleNext();
        } else {
          alert(cmot_details_check.message);
          return;
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }

    // step 6 Compliance & Declaration
    if (activeStep === 5) {
      const { isValid, errors } = validateDeclarationDetails(formData);
      console.log({ errors })
      if (!isValid) {
        setLoading(false);
        setDeclarationErrors(errors);
        return;
      } else {
        setDeclarationErrors({})
      }

      setOpenDialog(true);
      setLoading(false);
      dialogAction.current = async () => {

        const today = new Date();
        const updatedFormData = {
          ...formData,
          step: 6,
          team_members: Array.isArray(formData.team_members) ? JSON.stringify(formData.team_members) : null,
          ai_tools: Array.isArray(formData.ai_tools) ? JSON.stringify(formData.ai_tools) : null,
          Submission: today
        };

        try {
          const cmot_details_check = await postRequest(
            `cinemai/update/${id}`,
            updatedFormData
          );
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          if (cmot_details_check.status) {
            navigate(`/cinemai-hackathon/view/${id}`);
          } else {
            alert(cmot_details_check.message);
            return;
          }
        } catch (error) {
          console.error("Error:", error);
          setLoading(false);
        }
      };

    }

    // setCompleted(newCompleted);
    if (activeStep === steps.length - 1) {
    } else {
      // Check if the next step is not completed before proceeding
      if (!isStepCompleted(activeStep + 1)) {
      }
    }
    // await loadpreData();
  };

  const handleNext = async () => {
    // setActiveStep((prevActiveStep) => prevActiveStep + 1);

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const isStepCompleted = (step) => {
    return completed[step];
  };

  const handleSubmit = () => {
    // Placeholder function for form submission logic
    <Alert
      variant="filled"
      icon={<CheckIcon fontSize="inherit" />}
      severity="success"
    >
      Your Form is Success fully submitted
    </Alert>;
  };
  // Ensure formData.film_duration is a dayjs object or convert it if needed
  const getFilmDuration = (duration) => {
    if (dayjs.isDayjs(duration)) {
      return duration.format("mm:ss");
    }
    return dayjs(duration).format("mm:ss");
  };

  const renderStepContent = (step) => {
    // Render different step components based on activeStep
    switch (step) {
      case 0:
        return (
          <EntryDetails
            formData={formData}
            setFormData={setFormData}
            errors={EntryDetailErrors}
            setEntryDetailsErrors={setEntryDetailErrors}
          />
        );
      case 1:
        return (
          <TeamInfo
            formData={formData}
            setFormData={setFormData}
            errors={addressDetailsErrors}
            setTeamInfoErrors={setAddressDetailsErrors}
          />
        );
      case 2:
        return (
          <Aitools
            formData={formData}
            setFormData={setFormData}
            errors={atToolErrors}
            setAitoolsErrors={setAtToolErrors}

          />
        );
      case 3:
        return (
          <Aistages
            formData={formData}
            setFormData={setFormData}
            errors={atstageErrors}
            setAistagesErrors={setAtstageErrors}
          />
        );
      case 4:
        return (
          <Preview
            formData={formData}
            setFormData={setFormData}
          // errors={atstageErrors}
          // setAistagesErrors={setAtstageErrors}
          />
        );
      case 5:
        return (
          <Declaration
            formData={formData}
            setFormData={setFormData}
            errors={declarationErrors}
            setDeclarationErrors={setDeclarationErrors}
          />
        );
      default:
        return "Unknown step";
    }
  };

  const validateEntryDetails = (formData, serverErrors = {}) => {
    const {
      film_title,
      duration,
      genre_theme,
      synopsis,
      creative_note,
      ai_collaboration,
      film_link,
      creative_note_link
    } = formData;

    const errors = {};

    // Film Title validation
    if (!film_title || film_title.trim() === '') {
      errors.film_title = "Film / Project Title is required";
    }

    // Duration validation
    if (!duration || duration.trim() === '') {
      errors.duration = "Duration is required";
    } else {
      const numDuration = Number(duration);


      if (isNaN(numDuration)) {
        errors.duration = "Duration must be a valid number";
      } else if (numDuration < 2 || numDuration > 10) {
        errors.duration = "Duration must be between 2 and 10";
      }
    }

    // Genre/Theme validation
    if (!genre_theme || genre_theme.trim() === '') {
      errors.genre_theme = "Genre / Theme is required";
    }

    // Synopsis validation
    if (!synopsis || synopsis.trim() === '') {
      errors.synopsis = "Short Synopsis is required";
    } else {
      const wordCount = synopsis.trim().split(/\s+/).length;
      if (wordCount > 100) {
        errors.synopsis = "Short Synopsis cannot exceed 100 words.";
      }
    }

    // Creative Note validation
    let wordCount
    if (!creative_note || creative_note.trim() === '') {
      errors.creative_note = "Creative Note is required";
    } else {
      wordCount = creative_note.trim().split(/\s+/).length;
      if (wordCount > 250) {
        errors.creative_note = "Creative Note cannot exceed 250 words.";
      }
    }

    // AI Collaboration validation
    if (!ai_collaboration || ai_collaboration.trim() === '') {
      errors.ai_collaboration = "Human-AI Collaboration Narrative is required";
    } else {
      wordCount = ai_collaboration.trim().split(/\s+/).length;
      if (wordCount > 200) {
        errors.ai_collaboration = "Human-AI Collaboration Narrative cannot exceed 200 words.";
      }
      if (wordCount < 50) {
        errors.ai_collaboration = "Human-AI Collaboration Narrative cannot be less than  50 words.";
      }
    }

    // Film Link validation
    if (!film_link || film_link.trim() === '') {
      errors.film_link = "Film / Video File Link is required";
    } else {
      // Basic URL validation
      const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
      if (!urlRegex.test(film_link.trim())) {
        errors.film_link = "Please enter a valid URL";
      }
    }

    // Creative Note Link validation
    // if (!creative_note_link || creative_note_link.trim() === '') {
    //   errors.creative_note_link = "Creative Note Document Link is required";
    // } else {
    //   // Basic URL validation
    //   const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
    //   if (!urlRegex.test(creative_note_link.trim())) {
    //     errors.creative_note_link = "Please enter a valid URL";
    //   }
    // }

    // Optional fields (no validation required as they're optional)
    // film_link_password
    // creative_note_password

    // Merge server-side errors with client-side errors
    const mergedErrors = { ...errors, ...serverErrors };

    const isValid = Object.keys(mergedErrors).length === 0;
    return { isValid, errors: mergedErrors };
  };

  const validateTeamInfo = (formData) => {
    const {
      team_name,
      team_leader,
      email,
      phone,
      address,
      country,
      permanent_state,
      permanent_city,
      team_members,
      zipcode,
      teamleaderphoto
    } = formData;

    const errors = {};

    // Basic team information validation
    if (!teamleaderphoto || teamleaderphoto.trim() === '') {
      errors.teamleaderphoto = "Team leader photo is required";
    }
    if (!team_name || team_name.trim() === '') {
      errors.team_name = "Team Name is required";
    }

    if (!team_leader || team_leader.trim() === '') {
      errors.team_leader = "Team Leader is required";
    }
    if (!address || address.trim() === '') {
      errors.address = "Postal adress is required";
    }
    if (!zipcode || zipcode.trim() === '') {
      errors.zipcode = "Postal adress is required";
    }

    if (!email || email.trim() === '') {
      errors.email = "Email Address is required";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email.trim())) {
        errors.email = "Please enter a valid email address";
      }
    }

    if (!phone || phone.trim() === '') {
      errors.phone = "Phone Number is required";
    } else if (phone.length < 10) {
      errors.phone = "Phone number must be at least 10 digits";
    }

    if (!country || country.trim() === '') {
      errors.country = "Country is required";
    }

    // If country is India (101), validate state and city
    if (country === "101") {
      if (!permanent_state || permanent_state.trim() === '') {
        errors.permanent_state = "State is required";
      }
      if (!permanent_city || permanent_city.trim() === '') {
        errors.permanent_city = "City is required";
      }
    }

    // Team members validation
    const teamMembersArray = Array.isArray(team_members) ? team_members : [];
    console.log({ formData })
    if (teamMembersArray.length === 0) {
      errors.team_members_common = "At least one team member is required";
    } else {
      // Validate each team member
      teamMembersArray.forEach((member, index) => {
        if (!member.team_members_name || member.team_members_name.trim() === '') {
          errors[`team_members_${index}_name`] = "Team member name is required";
        }

        if (!member.team_members_email || member.team_members_email.trim() === '') {
          errors[`team_members_${index}_email`] = "Team member email is required";
        } else {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(member.team_members_email.trim())) {
            errors[`team_members_${index}_email`] = "Please enter a valid email address";
          }
        }

        if (!member.team_members_role || member.team_members_role.trim() === '') {
          errors[`team_members_${index}_role`] = "Team member role is required";
        }
      });
    }

    const isValid = Object.keys(errors).length === 0;
    return { isValid, errors };
  };
  const validateAiTool = (formData) => {
    const { ai_tools } = formData;

    const errors = {};

    // Ensure ai_tools is an array
    console.log({ ai_tools });
    const aiToolsArray = Array.isArray(ai_tools) ? ai_tools : [];

    // Check if at least one AI tool is added
    if (aiToolsArray.length === 0) {
      errors.ai_tools_common = "At least one AI tool is required";
      return { isValid: false, errors };
    }

    // Validate each AI tool
    aiToolsArray.forEach((tool, index) => {
      // Tool name validation
      if (!tool.tool_name || tool.tool_name.trim() === '') {
        errors[`ai_tools_${index}_tool_name`] = "AI Tool / Platform Name is required";
      }

      // Purpose/Function validation
      if (!tool.purpose_function || tool.purpose_function.trim() === '') {
        errors[`ai_tools_${index}_purpose_function`] = "Purpose / Function is required";
      }
      if (!tool.version || tool.version.trim() === '') {
        errors[`ai_tools_${index}_version`] = "version is required";
      }

      // Version is optional, so no validation needed
    });

    const isValid = Object.keys(errors).length === 0;
    return { isValid, errors };
  };
  const validateAiStage = (formData) => {
    const {
      concept_script_development,
      concept_script_development_description,
      storyboarding_pre_visualization,
      storyboarding_pre_visualization_description,
      video_generation_animation,
      video_generation_animation_description,
      editing_post_production,
      editing_post_production_description,
      sound_voice_music,
      sound_voice_music_description,
      other,
      other_description
    } = formData;

    const errors = {};

    // Check if at least one stage is selected
    // const hasSelectedStage =
    //   concept_script_development ||
    //   storyboarding_pre_visualization ||
    //   video_generation_animation ||
    //   editing_post_production ||
    //   sound_voice_music ||
    //   other;

    // if (!hasSelectedStage) {
    //   errors.ai_stages_common = "At least one production stage must be selected";
    // }

    // Validate descriptions for selected stages
    if (concept_script_development && !(concept_script_development == 'false')) {
      if (!concept_script_development_description || concept_script_development_description.trim() === '') {
        errors.concept_script_development_description = "Description for Concept / Script Development is required";
      } else {
        const wordCount = concept_script_development_description.trim().split(/\s+/).length;
        if (wordCount < 50) {
          errors.concept_script_development_description = "Description must be at least 50 words";
        } else if (wordCount > 200) {
          errors.concept_script_development_description = "Description cannot exceed 200 words";
        }
      }
    }

    if (storyboarding_pre_visualization && !(storyboarding_pre_visualization == 'false')) {
      if (!storyboarding_pre_visualization_description || storyboarding_pre_visualization_description.trim() === '') {
        errors.storyboarding_pre_visualization_description = "Description for Storyboarding / Pre-visualization is required";
      } else {
        const wordCount = storyboarding_pre_visualization_description.trim().split(/\s+/).length;
        if (wordCount < 50) {
          errors.storyboarding_pre_visualization_description = "Description must be at least 50 words";
        } else if (wordCount > 200) {
          errors.storyboarding_pre_visualization_description = "Description cannot exceed 200 words";
        }
      }
    }

    if (video_generation_animation && !(video_generation_animation == 'false')) {
      if (!video_generation_animation_description || video_generation_animation_description.trim() === '') {
        errors.video_generation_animation_description = "Description for Video Generation / Animation is required";
      } else {
        const wordCount = video_generation_animation_description.trim().split(/\s+/).length;
        if (wordCount < 50) {
          errors.video_generation_animation_description = "Description must be at least 50 words";
        } else if (wordCount > 200) {
          errors.video_generation_animation_description = "Description cannot exceed 200 words";
        }
      }
    }

    if (editing_post_production && !(editing_post_production == 'false')) {
      if (!editing_post_production_description || editing_post_production_description.trim() === '') {
        errors.editing_post_production_description = "Description for Editing / Post-production is required";
      } else {
        const wordCount = editing_post_production_description.trim().split(/\s+/).length;
        if (wordCount < 50) {
          errors.editing_post_production_description = "Description must be at least 50 words";
        } else if (wordCount > 200) {
          errors.editing_post_production_description = "Description cannot exceed 200 words";
        }
      }
    }

    if (sound_voice_music && !(sound_voice_music == 'false')) {
      if (!sound_voice_music_description || sound_voice_music_description.trim() === '') {
        errors.sound_voice_music_description = "Description for Sound / Voice / Music is required";
      } else {
        const wordCount = sound_voice_music_description.trim().split(/\s+/).length;
        if (wordCount < 50) {
          errors.sound_voice_music_description = "Description must be at least 50 words";
        } else if (wordCount > 200) {
          errors.sound_voice_music_description = "Description cannot exceed 200 words";
        }
      }
    }

    if (other && !(other == 'false')) {
      if (!other_description || other_description.trim() === '') {
        errors.other_description = "Description for Other Applications is required";
      } else {
        const wordCount = other_description.trim().split(/\s+/).length;
        if (wordCount < 50) {
          errors.other_description = "Description must be at least 50 words";
        } else if (wordCount > 200) {
          errors.other_description = "Description cannot exceed 200 words";
        }
      }
    }

    const isValid = Object.keys(errors).length === 0;
    return { isValid, errors };
  };
  const validateDeclarationDetails = (formData) => {
    const {
      ethical_original_licensed,
      ethical_no_harmful_content,
      ethical_consent_obtained,
      ethical_responsible_ai,
      declare_original_work,
      declare_ai_disclosure,
      declare_responsible_ai,
      declare_screening_rights,
      digital_signature,
      declaration_date,
      declaration_place,
      confirm
    } = formData;

    const errors = {};

    // Helper function to properly check checkbox values
    const isChecked = (value) => {
      if (typeof value === 'boolean') return value;
      if (value === 1 || value === '1' || value === 'true') return true;
      if (value === 0 || value === '0' || value === 'false' || value === null || value === undefined) return false;
      return Boolean(value);
    };

    // Ethical Compliance validation
    if (!isChecked(ethical_original_licensed)) {
      errors.ethical_original_licensed = "This field is required";
    }

    if (!isChecked(ethical_no_harmful_content)) {
      errors.ethical_no_harmful_content = "This field is required";
    }

    if (!isChecked(ethical_consent_obtained)) {
      errors.ethical_consent_obtained = "This field is required";
    }

    if (!isChecked(ethical_responsible_ai)) {
      errors.ethical_responsible_ai = "This field is required";
    }

    // Declaration validation
    if (!isChecked(declare_original_work)) {
      errors.declare_original_work = "This field is required";
    }

    if (!isChecked(declare_ai_disclosure)) {
      errors.declare_ai_disclosure = "This field is required";
    }

    if (!isChecked(declare_responsible_ai)) {
      errors.declare_responsible_ai = "This field is required";
    }

    if (!isChecked(declare_screening_rights)) {
      errors.declare_screening_rights = "This field is required";
    }

    // Signature and details validation
    if (!digital_signature || digital_signature.trim() === '') {
      errors.digital_signature = "Name / Signature is required";
    }

    if (!declaration_date) {
      // errors.declaration_date = "Date is required";
    } else {
      // Optional: Validate that date is not in the future
      // const selectedDate = new Date(declaration_date);
      // const today = new Date();
      // today.setHours(23, 59, 59, 999); // Set to end of day for comparison
      // if (selectedDate > today) {
      //   errors.declaration_date = "Date cannot be in the future";
      // }
    }

    if (!declaration_place || declaration_place.trim() === '') {
      errors.declaration_place = "Place is required";
    }

    if (!isChecked(confirm)) {
      errors.confirm = "This confirmation is required";
    }

    const isValid = Object.keys(errors).length === 0;
    return { isValid, errors };
  };
  const CustomStepIconRoot = styled("div")(({ theme, ownerState }) => ({
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.grey[700]
        : theme.palette.grey[300],
    zIndex: 1,
    color: "#fff",
    width: 24,
    height: 24,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    ...(ownerState.active && {
      // backgroundColor: theme.palette.primary.main,
      backgroundColor: "#1c5768",
    }),
    ...(ownerState.completed && {
      // backgroundColor: theme.palette.primary.main,
      backgroundColor: "#1c5768",
    }),
  }));

  function CustomStepIcon(props) {
    const { active, completed, className } = props;

    return (
      <CustomStepIconRoot
        ownerState={{ completed, active }}
        className={className}
      >
        {completed ? (
          <CheckIcon style={{ color: "white", fontSize: "20px" }} />
        ) : null}
        {active ? (
          <CheckIcon style={{ color: "white", fontSize: "20px" }} />
        ) : null}
      </CustomStepIconRoot>
    );
  }

  return (
    <>
      {/* Header section with logos */}

      <div className="">
        <div className="d-flex justify-content-between m-3 align-items-center">
          <div className="imgLogo">
            <a href={process.env.REACT_APP_BASE_PREFIX + "/dashboard"}>
              <img
                src={logo}
                alt="Logo"
                style={{ width: "140px", height: "120px" }}
              />
            </a>
          </div>
          <div className="imgLogo">
            <img
              src={logo1}
              alt="Logo"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <div className="imgLogo">
            <img
              src={logo2}
              alt="Logo"
              style={{ width: "200px", height: "100px" }}
            />
          </div>
        </div>
        <Container>
          <div className="text-center m-3">
            <h5>CinemAI Hackathon: Pre-Evaluation Submission Form</h5>
          </div>
          <div className="m-3 d-flex justify-content-between">
            <Button
              variant="outlined"
              href={process.env.REACT_APP_BASE_PREFIX + "/dashboard/cinemai-hackathon"}
            >
              Dashboard
            </Button>
            <Button
              variant="outlined"
              href={process.env.REACT_APP_BASE_PREFIX + "/logout"}
              color="error"
            >
              Log Out
            </Button>
          </div>
        </Container>
      </div>
      {/* Main content section */}
      <Container>
        {loading && <Loader />} {/* Display loader when loading is true */}
        {!loading && (
          <Box sx={{ width: "100%" }}>
            {/* Stepper component to navigate through steps */}
            <Stepper activeStep={activeStep} className="comtsteper">
              {steps.map((label, index) => (
                <Step key={label}>
                  <StepLabel StepIconComponent={CustomStepIcon}>
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>

            {/* Render step content based on activeStep */}
            {activeStep === steps.length ? (
              // Show submission button when on the last step
              <React.Fragment>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button onClick={handleSubmit} className="bttnn">
                    Submit
                  </Button>
                </Box>
              </React.Fragment>
            ) : (
              // Show current step content and navigation buttons
              <React.Fragment>
                <Typography sx={{ mt: 2, mb: 1 }}>
                  {renderStepContent(activeStep)}
                </Typography>
                <Box
                  sx={{ pb: 2, display: "flex", flexDirection: "row", pt: 2 }}
                >
                  <Button
                    variant="outlined"
                    color="inherit"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                  >
                    <ChevronLeftIcon /> Back
                  </Button>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button onClick={handleComplete} className="bttnn">
                    {/* {activeStep === steps.length - 1 ? 'Finish' : 'Next'} */}
                    {activeStep === steps.length - 1
                      ? "Finish"
                      : activeStep === 5
                        ? "Submit"
                        : "Next"}
                    <NavigateNextIcon style={{ color: "white" }} />
                  </Button>
                </Box>
              </React.Fragment>
            )}
          </Box>
        )}
      </Container>
      {/* Confirmation Dialog */}
      <Dialog open={openDialog} onClose={() => handleDialogClose(false)}>
        <DialogTitle>Are You Sure?</DialogTitle>
        <DialogContent>
          Once submitted, the form cannot be edited/resubmitted. Do you want to
          proceed?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleDialogClose(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={() => handleDialogClose(true)} color="primary">
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CinemaStepperData;
